import { motion } from 'framer-motion'
import { AlertCircle } from 'lucide-react'
import type { LoginFlow } from '@/components/Login/loginTypes'

type LoginAlertsProps = {
  flow: LoginFlow
  showSuccess?: boolean
}

export function LoginAlerts({ flow, showSuccess = true }: LoginAlertsProps) {
  return (
    <>
      {flow.rateLimit.attempts > 0 && !flow.rateLimit.isLocked && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className={`login-error rate-limit-warning ${flow.rateLimit.getAlertLevel()}`}
        >
          <AlertCircle size={16} />
          <span>{flow.rateLimit.getWarningMessage()}</span>
        </motion.div>
      )}

      {flow.rateLimit.isLocked && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="login-error rate-limit-locked"
        >
          <AlertCircle size={16} />
          <span>{flow.rateLimit.getWarningMessage()}</span>
        </motion.div>
      )}

      {flow.error && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="login-error"
          role="alert"
        >
          <AlertCircle size={16} />
          <span>{flow.error}</span>
        </motion.div>
      )}

      {showSuccess && flow.successMessage && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="login-error login-success"
        >
          <span>{flow.successMessage}</span>
        </motion.div>
      )}
    </>
  )
}
